export default __webpack_public_path__ + "9c34ce766c349b8a9d6646900091aae3.svg";